import { z } from 'zod';

/**
 * @see ConstantsService::SEXES
 */
export enum SEXES {
  MALE = 'male',
  FEMALE = 'female',
}

export const SexSchema = z.nativeEnum(SEXES);
export type TSex = z.infer<typeof SexSchema>;
